import { Box, Button, ButtonGroup, Card, CardContent, CardHeader, Grid, Tab, Tabs, Typography, Container } from "@mui/material"
import { MainLoggedInLayout } from "../../components/layouts/main.loggedIn.layout"
import { useNavigate } from "react-router"
import { useContext, useEffect, useMemo, useState } from "react";
import { searchAllCommunities } from "../../controllers/community/community";
import { useQuery } from "@tanstack/react-query";
import { UserContext } from "../../context/UserContext";
import { CategoryDisplay } from "../../components/category.display"
import { SearchWidget } from "../../components/search.widget";
import CategoryFilter from "../../components/category.filter";
import { Tune } from "@mui/icons-material";
import { useProfileComplete } from "../../hooks/useProfileComplete";

export const para_label = {fontWeight:'bolder', margin:5, fontSize:12}

export const CommunityCard = ({card_details, navigate}) => {
    return(
        <Card 
            sx={{ 
                position: "relative", 
                cursor: 'pointer', 
                height: 200,
                borderRadius: 2,
                overflow: 'hidden',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
                }
            }} 
            onClick={() => navigate("/community/show/"+card_details?._id)}
        >      
            <Box
                sx={{
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundImage: `url('${card_details.header_img}')`,
                    height: '100%',
                    position: 'relative'
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)'
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        p: 2,
                        color: '#ffffff'
                    }}
                >
                    <Typography variant="h6" sx={{ color: '#00ff40', fontWeight: 'bold', mb: 1 }}>
                        {card_details.title}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                        {card_details.member.length} members joined
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                        {card_details.statuses.length} posts
                    </Typography>
                    <CategoryDisplay label={card_details.category} hideLabel={true} />
                </Box>
            </Box>
        </Card>
    )
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export const ListCommunity = () => {
    const { userDetails } = useContext(UserContext)
    let token = userDetails?.token
    
    // Check profile completion and redirect if needed
    useProfileComplete(userDetails)
    
    const [title, setTitle] =  useState('')
    const [category, setCategory] = useState('')
    const [categories, setCategories] = useState([])
    const [page_number, setPageNum] = useState(0)
    const [showCatFilter, setShowCatFilter] = useState(false)
    let limit = 8
    const { data:communities, refetch } = useQuery({ queryKey: ['searchAllCommunites'], queryFn: () => searchAllCommunities({token, title, page_number, category, limit}) })
    useEffect(() => {
        refetch()
    })
    let listCommunities = useMemo(() => communities?.community ?? [],[communities?.community])
    const [allCommunities, setAllCommunities] = useState([])
    const [tempCommunities, setTempCommunities] = useState([])

    useEffect(() => {
        listCommunities.filter(item => setTempCommunities(allCommunities => [...allCommunities, item]))
        let localCats = []
        listCommunities.filter(item => item.category && !localCats.includes(item.category) && localCats.push(item.category))
        setCategories(localCats)
    }, [listCommunities])

    useEffect(() => {
        let jsonObject = tempCommunities.map(JSON.stringify);
        let uniqueSet = new Set(jsonObject);
        let uniqueArray = Array.from(uniqueSet).map(JSON.parse);

        setAllCommunities(uniqueArray)
    }, [tempCommunities])

    useEffect(() => {
      setPageNum(0)
      if(title || category){
        setAllCommunities([])
        setTempCommunities([])
      }
    }, [title, category])
    
    
    let navigate = useNavigate()
    const [value, setValue] = useState(1);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    
    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 10;
        if (bottom && listCommunities.length === limit) { 
            setTimeout(() => {
                setPageNum(page_number+1)
            }, 100);
        }
    }

    // Add scroll event listener to the container
    useEffect(() => {
        const container = document.querySelector('[data-scroll-container]');
        if (container) {
            container.addEventListener('scroll', handleScroll);
            return () => container.removeEventListener('scroll', handleScroll);
        }
    }, [handleScroll]);
    return (
        <MainLoggedInLayout>
            <Container maxWidth="lg" sx={{ py: 2 }}>
                <Card sx={{ 
                    overflowY: 'auto', 
                    maxHeight: '95vh', 
                    scrollbarWidth: 'none',
                    borderRadius: 2,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                }} 
                data-scroll-container
                onScroll={handleScroll}
                >
                    <CardHeader 
                        title={
                            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
                                {value === 0 ? "My Communities" : "All Communities"}
                            </Typography>
                        }
                        subheader={
                            <Button 
                                variant="contained" 
                                size="large"
                                onClick={() => navigate("/community/create")}
                                sx={{ 
                                    mt: 1,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 'bold'
                                }}
                            >
                                Create A Community
                            </Button>
                        }
                        sx={{ pb: 1 }}
                    />

                    <Box sx={{ borderBottom: 1, borderColor: 'divider', mx: 2 }}>
                        <Tabs 
                            value={value} 
                            onChange={handleChange} 
                            aria-label="community tabs"
                            sx={{
                                '& .MuiTab-root': {
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    fontSize: '1rem'
                                }
                            }}
                        >
                            <Tab label="My Communities" {...a11yProps(0)} />
                            <Tab label="All Communities" {...a11yProps(1)} />
                        </Tabs>
                    </Box>

                    <Box sx={{ p: 2, backgroundColor: '#f8f9fa' }}>
                        <Box sx={{ mb: 2 }}>
                            <SearchWidget search={title} setSearch={setTitle} />
                        </Box>
                        <ButtonGroup variant="outlined" sx={{ borderRadius: 2 }}>
                            <Button 
                                onClick={() => setShowCatFilter(!showCatFilter)}
                                sx={{ 
                                    textTransform: 'none',
                                    fontWeight: 'bold'
                                }}
                            >
                                Category <Tune sx={{ ml: 1 }} />
                            </Button>
                            <Button 
                                onClick={() => {
                                    setTitle('');
                                    setCategory('');
                                    setShowCatFilter(false);
                                }}
                                sx={{ 
                                    textTransform: 'none',
                                    fontWeight: 'bold'
                                }}
                            >
                                Reset Filters
                            </Button>
                        </ButtonGroup>
                        {showCatFilter && (
                            <Box sx={{ mt: 2 }}>
                                <CategoryFilter catgories={categories} category={category} setCategory={setCategory} />
                            </Box>
                        )}
                    </Box>

                    <CustomTabPanel value={value} index={0}>
                        <CardContent sx={{ p: 3 }}>
                            {allCommunities.filter(community => 
                                community.leader.includes(userDetails?.id) || community.member.includes(userDetails?.id)
                            ).length > 0 ? (
                                <Grid container spacing={3}>
                                    {allCommunities.map((community, index) => (
                                        (community.leader.includes(userDetails?.id) || community.member.includes(userDetails?.id)) && (
                                            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                                <CommunityCard card_details={community} navigate={navigate} userDetails={userDetails} />
                                            </Grid>
                                        )
                                    ))}
                                </Grid>
                            ) : (
                                <Box sx={{ textAlign: 'center', py: 8 }}>
                                    <Typography variant="h6" color="text.secondary" gutterBottom>
                                        You haven't joined any communities yet
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                        Discover and join communities that match your interests
                                    </Typography>
                                    <Button 
                                        variant="contained" 
                                        onClick={() => setValue(1)}
                                        sx={{ mr: 2 }}
                                    >
                                        Browse All Communities
                                    </Button>
                                    <Button 
                                        variant="outlined" 
                                        onClick={() => navigate("/community/create")}
                                    >
                                        Create New Community
                                    </Button>
                                </Box>
                            )}
                        </CardContent>
                    </CustomTabPanel>
                    
                    <CustomTabPanel value={value} index={1}>
                        <CardContent sx={{ p: 3 }}>
                            {allCommunities.length > 0 ? (
                                <Grid container spacing={3}>
                                    {allCommunities.map((community, index) => (
                                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                            <CommunityCard card_details={community} navigate={navigate} userDetails={userDetails} />
                                        </Grid>
                                    ))}
                                </Grid>
                            ) : (
                                <Box sx={{ textAlign: 'center', py: 8 }}>
                                    <Typography variant="h6" color="text.secondary" gutterBottom>
                                        No communities found
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                        Be the first to create a community and start building your network
                                    </Typography>
                                    <Button 
                                        variant="contained" 
                                        onClick={() => navigate("/community/create")}
                                    >
                                        Create First Community
                                    </Button>
                                </Box>
                            )}
                        </CardContent>
                    </CustomTabPanel>
                </Card>
            </Container>
        </MainLoggedInLayout>
    )
}